import React, { useState } from 'react';
import theme from './BuyerChangeRequestOfferGroup.module.scss';
import { ChangeRequestProgressInfoOfferGroup } from '@/types';
import { getOpenBuyerOfferAttachmentUrl } from '@/services/buyer-offers';
import ProfileAndUserDisplay from '@/components/ProfileAndUserDisplay';
import { Trans } from '@lingui/react/macro';
import AttachmentList from '@/components/AttachmentList';
import { ExpandableCard, ExpandableCardHandle, CardSection } from '@/components/Cards';
import { BuyerCurrencyDisplay } from '@/buyer/components/BuyerCurrencyDisplay';
import { BuyerChangeRequestParticipantOfferLines } from '@/buyer/components/BuyerChangeRequestParticipantOfferLines';
import { getOpenExternalAgreementFileUrl } from '@/services/external-agreements';

interface BuyerChangeRequestOfferGroupProps {
    group: ChangeRequestProgressInfoOfferGroup;
    isPreview?: boolean;
}

const BuyerChangeRequestOfferGroup: React.FC<BuyerChangeRequestOfferGroupProps> = ({ group, isPreview }) => {
    const [expanded, setExpanded] = useState(true);

    const isEmpty = !group.note && group.attachments.length === 0 && (!group.offerLines || group.offerLines.length === 0);

    const renderExpandContent = () => {
        const getAttachmentUrl = isPreview ? getOpenExternalAgreementFileUrl : getOpenBuyerOfferAttachmentUrl;

        return (
            <div className={theme.container}>
                {group.note && (
                    <>
                        <h6>
                            <Trans>Offer message</Trans>
                        </h6>
                        <div className={theme.note}>{group.note}</div>
                    </>
                )}
                {group.offerLines && group.offerLines.length > 0 && (
                    <BuyerChangeRequestParticipantOfferLines offerLines={group.offerLines} />
                )}

                {group.attachments.length > 0 && (
                    <>
                        <h6>
                            <Trans>Attachments</Trans>
                        </h6>
                        <AttachmentList
                            value={group.attachments}
                            urlGenerator={(att) => getAttachmentUrl(att.id)}
                            canEdit={false}
                            canAdd={false}
                        />
                    </>
                )}
            </div>
        );
    };
    return (
        <ExpandableCard expanded={expanded} expandableContent={renderExpandContent()} type="inside-bordered" variant="buyer">
            <CardSection>
                <ProfileAndUserDisplay
                    userId={group.providedByUser.id}
                    userName={group.providedByUser.name}
                    profileId={group.providedByProfile.id}
                    profileName={group.providedByProfile.name}
                />
            </CardSection>

            {group.price != null && (
                <CardSection caption={<Trans>Total</Trans>} right className="text-right">
                    <BuyerCurrencyDisplay value={group.price} />
                </CardSection>
            )}

            {isEmpty ? (
                <CardSection width="130px" right />
            ) : (
                <ExpandableCardHandle onExpandToggle={setExpanded} expanded={expanded} width="130px" />
            )}
        </ExpandableCard>
    );
};

export default BuyerChangeRequestOfferGroup;
